import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './index.css';

const Notification = ({ count, max, className }) => {
  if (!count) {
    return null;
  }
  const cls = classnames(styles.notification, className);
  if (max && max < count) {
    return (
      <span className={cls} data-max={max}>
        <span className={styles.number}>{max}</span>
      </span>
    );
  }
  return (
    <span className={cls}>
      <span className={styles.number}>{count}</span>
    </span>
  );
};

Notification.propTypes = {
  /** the number of changed elements */
  count: PropTypes.number,
  /** Hand over a max value, e.g. 99 which leads to a display of '99+' if count exceeds max */
  max: PropTypes.number,
  /** add a custom className to the component */
  className: PropTypes.string,
};

Notification.defaultProps = {
  count: 0,
  max: 99,
};

Notification.displayName = 'Notification';

export default Notification;
